import { makeStyles, tokens, shorthands } from "@fluentui/react-components";

const novataNavy = "#0f1f33";
const novataMutedText = "#5b6b7c";
const novataPanelBg = "#f4f6f8";
const novataDivider = "#e5e9ee";

export const useHeaderStyles = makeStyles({
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: tokens.spacingVerticalL,
    padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalL}`,
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.borderRadius(tokens.borderRadiusLarge),
    boxShadow: tokens.shadow4,
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
  },
  logo: {
    height: "20px",
    width: "auto",
    objectFit: "contain",
  },
  headerRight: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalL,
  },
  avatar: {
    cursor: "pointer",
    ...shorthands.transition("transform", "0.2s", "ease-in-out"),
    ":hover": {
      transform: "scale(1.05)",
    },
  },
  menuPopover: {
    minWidth: "260px",
    padding: 0,
    overflow: "hidden",
    fontFamily:
      '"Poppins", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  userInfo: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    padding: `${tokens.spacingVerticalL} ${tokens.spacingHorizontalL}`,
    backgroundColor: novataPanelBg,
    border: "none",
    borderBottom: `1px solid ${novataDivider}`,
    cursor: "pointer",
    textAlign: "center",
    ...shorthands.transition("background-color", "0.15s", "ease-in-out"),
    ":hover": {
      backgroundColor: "#eceff3",
    },
    ":focus-visible": {
      outline: `2px solid ${novataNavy}`,
      outlineOffset: "-2px",
    },
  },
  userInfoAvatar: {
    marginBottom: tokens.spacingVerticalS,
  },
  userInfoName: {
    fontSize: "16px",
    fontWeight: 600,
    color: novataNavy,
    lineHeight: "1.3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  userInfoEmail: {
    fontSize: "13px",
    fontWeight: 400,
    color: novataMutedText,
    lineHeight: "1.4",
    marginTop: "2px",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  activeOrg: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: tokens.spacingVerticalM,
    paddingTop: tokens.spacingVerticalS,
    width: "100%",
    borderTop: `1px solid ${novataDivider}`,
  },
  activeOrgLabel: {
    fontSize: "11px",
    fontWeight: 500,
    color: novataMutedText,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    lineHeight: "1.4",
  },
  activeOrgName: {
    fontSize: "13px",
    fontWeight: 600,
    color: novataNavy,
    lineHeight: "1.4",
    marginTop: "2px",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  menuItem: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    minWidth: "180px",
    padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalL}`,
    width: "100%",
  },
  menuIcon: {
    width: "20px",
    height: "20px",
    flexShrink: 0,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: tokens.spacingHorizontalM,
    color: novataNavy,
  },
  menuItemLabel: {
    fontSize: "14px",
    fontWeight: 500,
    color: novataNavy,
    flex: 1,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "inline-block",
    lineHeight: "1.5",
  },
});
